import DateTime from "../../external/luxon/src/datetime.js";
import "../../external/luxon/src/duration.js";
import { useMemo } from "react";
const useDateSelector = (date, monthCount) => useMemo(() => {
  const luxonDate = date ? DateTime.fromISO(date) : DateTime.now(), months = [{ monthDate: luxonDate.toISODate() }];
  return monthCount === 2 && months.push({
    monthDate: luxonDate.plus({ month: 1 }).toISODate()
  }), months;
}, [date, monthCount]);
export {
  useDateSelector
};
//# sourceMappingURL=useDateSelector.js.map
